import { render, staticRenderFns } from "./MaintenanceRecord.vue?vue&type=template&id=45a56097&scoped=true&"
import script from "./MaintenanceRecord.vue?vue&type=script&lang=js&"
export * from "./MaintenanceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a56097",
  null
  
)

export default component.exports